import { UpdateParameter } from '../../common/LiveboardVisuals/LiveboardVisuals.types';

export function getUpdateParametersForTimezone(timezone: string): UpdateParameter[] {
  return [{ name: 'Timezone', value: timezone, isVisibleToUser: true }];
}

export function getUpdateParametersForTimeRange({
  startDate,
  endDate,
}: {
  startDate: Date;
  endDate: Date;
}): UpdateParameter[] {
  return [
    { name: 'Start Date', value: Math.floor(startDate.getTime() / 1000), isVisibleToUser: true },
    { name: 'End Date', value: Math.floor(endDate.getTime() / 1000), isVisibleToUser: true },
  ];
}
